// Orgs the frontend configures by id until per-org connector metadata comes
// from the backend.
export const TOGETHER_ORG_ID = 'd6ad3232-0a57-4554-a54e-16d32ba7d6e2';
export const TOGETHER_ORIGIN = 'https://together.usecapitol.com';
